/* eslint-disable no-restricted-syntax */

import {currentUserChangeDispatcher} from './user'
import {BACKEND} from '~/config'
import {handleHttpError} from '~/services/error'
import {http} from '~/utils/http'

const audioElement = document.createElement('audio')

//TODO определять ssml внешним флагом (переделка вёрстки в синтезе лендинг и лк)
function prepareSynthesisText(text: string) {
    return text.trimStart().startsWith('<speak>') && text.trimEnd().endsWith('</speak>')
        ? {ssml: text}
        : {text}
}

export function synthesize(
    voiceId: string,
    text: string,
    speed: number,
    language = 'auto',
    sampleRate?: number,
    emotion?: string,
) {
    return http.post<Blob>(`${BACKEND.api}/tts/synthesize`, {
        voice: voiceId,
        language,
        speed,
        sample_rate: sampleRate,
        emotion,
        ...prepareSynthesisText(text),
    })
        .catch(handleHttpError)
}

export function synthesizeDemo(
    voiceId: string,
    text: string,
    speed: number,
    language = 'auto',
    emotion?: string,
) {
    return http.post<Blob>(`${BACKEND.api}/demo/tts/synthesize`, {
        voice: voiceId,
        language,
        speed,
        emotion,
        ...prepareSynthesisText(text),
    })
        .catch(handleHttpError)
}

type Emotion = {
    name: string
    display_name: string
}

export type Voice = {
    id: string
    name: string
    version: string
    //gender?: 'f' | 'm'
    languages: string[]
    emotions?: Emotion[]
}

let voiceCache: Promise<Voice[]> | undefined

currentUserChangeDispatcher.subscribe(() => voiceCache = undefined)

export function getVoices() {
    return voiceCache ||= http.get<{data: Voice[]}>(`${BACKEND.api}/tts/voices`)
        .then(({data}) => data)
        .catch(error => {
            voiceCache = undefined
            throw error
        })
        .catch(handleHttpError)
}

// TODO убрать, когда бэкенд начнет возвращать лимит
export const demoSynthesisCharacterLimit = 500

let demoVoiceCache: Promise<Voice[]> | undefined

export function getDemoVoices() {
    return demoVoiceCache ||= http.get<{data: Voice[]}>(`${BACKEND.api}/demo/tts/voices`)
        .then(({data}) => data)
        .catch(error => {
            demoVoiceCache = undefined
            throw error
        })
        .catch(handleHttpError)
}

export function playAudio(src: string) {
    audioElement.src = src

    return audioElement.play()
}

export function pauseAudio() {
    audioElement.pause()
}

export function resumeAudio() {
    audioElement.play()
}

export function subscribeOnEvents(handlers: Partial<Record<keyof HTMLMediaElementEventMap, () => void>>) {
    const items = Object.entries(handlers)

    items.forEach(([key, handler]) => audioElement.addEventListener(key, handler))

    return () => items.forEach(([key, handler]) => audioElement.removeEventListener(key, handler))
}

export type SoundStatus = 'playing' | 'paused' | 'stopped'

export const exampleTexts: {[Key: string]: string | undefined, default: string} = {
    default: [
        'Приветствуем на демонстрации синтеза речи.\n',
        '\n',
        'Современные алгоритмы искусственного интеллекта преобразуют текст ',
        'в плавную и естественную речь. Оцените ',
        'чёткость произношения, интонацию и отсутствие механических пауз.\n',
        '\n',
        'Дауысты, жылдамдықты және эмоционалды бояуды реттеңіз, дыбысты қабылдауға мүмкіндігінше ',
        'ыңғайлы етіңіз.\n',
        '\n',
        'You can also choose the synthesis language, but so far only Russian, English and Kazakh are available. ',
        'Choose a voice and customize it to suit any of your tasks!',
    ]
        .join(''),
    ru: [
        'Приветствуем на демонстрации синтеза речи.\n',
        '\n',
        'Современные алгоритмы искусственного интеллекта преобразуют текст ',
        'в плавную и естественную речь. Оцените чёткость ',
        'произношения, интонацию и отсутствие механических пауз.\n',
        '\n',
        'Настраивайте голос, скорость и эмоциональную окраску, ',
        'делая звучание максимально комфортным для восприятия. Вы также можете выбрать ',
        'язык озвучивания, но пока доступны только русский, английский и казахский. Выберите озвучку ',
        'и настройте ее в соответствии с вашими потребностями!',
    ]
        .join(''),
    en: [
        'Welcome to the speech synthesis demo.\n',
        '\n',
        'Modern artificial intelligence algorithms transform text ',
        'into smooth and natural speech. Evaluate ',
        'the clarity of pronunciation, intonation, and the absence of mechanical pauses.\n',
        '\n',
        'Adjust the synthesis voice, speed, and emotional tone, ',
        'making the sound as natural as possible. You can also choose the ',
        'synthesis language, but so far only Russian, English and Kazakh are available. Choose a voice ',
        'and customize it to suit any of your tasks!',
    ]
        .join(''),
    kk: [
        'Сөйлеу синтезі көрсетіліміне қош келдіңіз.\n',
        '\n',
        'Қазіргі заманғы жасанды интеллект алгоритмдері мәтінді табиғи ',
        'сөйлеуіне айналдырады. Айтылымның анықтығын, интонациясын және механикалық ',
        'үзілістердің жоқтығын бағалаңыз.\n',
        '\n',
        'Дауысты, жылдамдықты және эмоционалды бояуды реттеңіз, дыбысты қабылдауға мүмкіндігінше ',
        'ыңғайлы етіңіз. Сіз сондай-ақ синтез тілін таңдай аласыз, бірақ әзірге тек қазақ, ағылшын және орыс ',
        'тілдері қол жетімді. Дауысыңызды таңдап, оны қажеттіліктеріңізге сәйкес реттеңіз!',
    ]
        .join(''),
}
